<template>
  <user-login-wrapper>
    <el-card shadow="always" class="list-card-class">
      <template #header>
        <div class="card-header">
          <span>申請件名一覧</span>
        </div>
      </template>
      <el-form :model="form" :rules="rules" ref="formRef">
        <!-- 検索項目 -->
        <el-collapse :accordion="true">
          <el-row class="mb-0" :gutter="10">
            <el-col :span="2">
              <label class="text-sm">申請番号</label>
              <el-form-item prop="applicant_number" class="applicant_number">
                <jr-text v-model="form.applicant_number" size="small"></jr-text>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <label class="text-sm">申請日</label>
              <el-form-item prop="applicant_date_start" class="applicant_date_start">
                <el-form-item prop="applicant_date_end" class="applicant_date_end">
                  <jr-date-range-picker
                    class="plan_date-range-picker"
                    v-model:start="form.applicant_date_start"
                    v-model:end="form.applicant_date_end"
                    size="small"
                  >
                  </jr-date-range-picker>
                </el-form-item>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <label class="text-sm"> 担当保守区 </label>
              <el-form-item prop="department_id" class="department_id">
                <Suspense>
                  <department-select
                    v-model="form.department_id"
                    :nullable="true"
                    size="small"
                    :isInstitution="true"
                    :isElectricity="true"
                  />
                </Suspense>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <label class="text-sm">標題</label>
              <el-form-item prop="applicant_title" class="applicant_title">
                <jr-text v-model="form.applicant_title" size="small"></jr-text>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <label class="text-sm"> 線名 </label>
              <el-form-item prop="line_code" class="line_code">
                <Suspense>
                  <line-select v-model="form.line_code" size="small" :nullable="true" />
                </Suspense>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <label class="text-sm">キロ程開始</label>
              <el-form-item prop="meter_start" class="meter_start">
                <input-kilo v-model="form.meter_start" size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <label class="text-sm">キロ程終了</label>
              <el-form-item prop="meter_end" class="meter_end">
                <input-kilo v-model="form.meter_end" size="small" />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <label class="text-sm">駅</label>
              <el-form-item prop="station_id" class="station_id">
                <Suspense>
                  <station-select
                    v-model="form.station_id"
                    size="small"
                    :nullable="true"
                    :lineCode="form.line_code"
                    :filterByLine="true"
                  />
                </Suspense>
              </el-form-item>
            </el-col>
          </el-row>
          <el-collapse-item title="状態検索" name="on">
            <el-row class="mb-3" :gutter="10">
              <el-col :span="3">
                <label class="text-sm"> 要否判断 </label>
                <el-form-item prop="judge_discussion_status" class="judge_discussion_status">
                  <status-select
                    class="judge-discussion-status-select"
                    :statuses="judgeDiscussion"
                    v-model="form.judge_discussion_status"
                    size="small"
                  >
                  </status-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <label class="text-sm"> 事前協議 </label>
                <el-form-item prop="prior_discussion_status" class="prior_discussion_status">
                  <status-select
                    class="prior-discussion-status-select"
                    :statuses="priorDiscussion"
                    v-model="form.prior_discussion_status"
                    size="small"
                  >
                  </status-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <label class="text-sm"> 協議書 </label>
                <el-form-item prop="discussion_document_status" class="discussion_document_status">
                  <status-select
                    class="discussion-document-status-select"
                    :statuses="discussionDocument"
                    v-model="form.discussion_document_status"
                    size="small"
                  >
                  </status-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <label class="text-sm"> 現地立会 </label>
                <el-form-item prop="witness_status" class="witness_status">
                  <status-select
                    class="witness-status-select"
                    :statuses="witness"
                    v-model="form.witness_status"
                    size="small"
                  >
                  </status-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <label class="text-sm"> 回答 </label>
                <el-form-item prop="answer_status" class="answer_status">
                  <status-select
                    class="answer-status-select"
                    :statuses="answer"
                    v-model="form.answer_status"
                    size="small"
                  >
                  </status-select>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <label class="text-sm"> 覚書等 </label>
                <el-form-item prop="adversaria_status" class="adversaria_status">
                  <status-select
                    class="adversaria-status-select"
                    :statuses="adversaria"
                    v-model="form.adversaria_status"
                    size="small"
                  >
                  </status-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <el-row class="my-2" justify="end">
        <el-col :span="2">
          <jr-button type="success" class="export-button" @click="print()"> 出力 </jr-button>
        </el-col>
        <el-col :span="2">
          <jr-button type="success" class="search" @click="search(true)"> 検索 </jr-button>
        </el-col>
      </el-row>
      <el-table
        class="my-1 w-100 table-header-fixed-for-iPad"
        :data="list"
        size="mini"
        height="470"
        border
        ref="elTableRef"
        @sort-change="sortChange"
        :cell-class-name="colorsCellClass"
        :cell-style="colorsCellStyle"
        class-name="list-table-class"
        :default-sort="{ prop: sortKey, order: orderCondition }"
      >
        <!-- 申請番号 -->
        <el-table-column
          prop="disp_applicant_number"
          :label="colMap.disp_applicant_number[keyMap.headerLabel]"
          :width="colMap.disp_applicant_number[keyMap.columnWidth]"
          :label-class-name="colMap.disp_applicant_number[keyMap.labelClass]"
          sortable="custom"
          align="left"
          header-align="center"
          fixed
          header-row-style="position:sticky;"
          class-name="disp_applicant_number"
        >
          <template #default="scope">
            <router-link
              class="detail"
              :to="{ name: 'ProximityDetail', params: { request_header_id: scope.row.request_header_id } }"
            >
              {{ scope.row.disp_applicant_number }}
            </router-link>
          </template>
        </el-table-column>
        <!-- 保守区 -->
        <el-table-column
          prop="disp_department_name"
          :label="colMap.disp_department_name[keyMap.headerLabel]"
          :width="colMap.disp_department_name[keyMap.columnWidth]"
          :label-class-name="colMap.disp_department_name[keyMap.labelClass]"
          header-align="center"
          show-overflow-tooltip
          align="left"
          sortable="custom"
          class-name="disp_department_name"
          fixed
        />
        <!-- 申請者 -->
        <el-table-column
          :label="colMap.applicant_label[keyMap.headerLabel]"
          :width="colMap.disp_applicant_business_name[keyMap.columnWidth]"
          header-align="center"
          fixed
        >
          <!-- 事業者 -->
          <el-table-column
            prop="disp_applicant_business_name"
            :label="colMap.disp_applicant_business_name[keyMap.headerLabel]"
            :width="colMap.disp_applicant_business_name[keyMap.columnWidth]"
            :label-class-name="colMap.disp_applicant_business_name[keyMap.labelClass]"
            align="left"
            header-align="center"
            show-overflow-tooltip
            sortable="custom"
            class-name="disp_applicant_business_name"
          />
          <!-- 担当者 -->
          <el-table-column
            prop="disp_applicant_manager_name"
            :label="colMap.disp_applicant_manager_name[keyMap.headerLabel]"
            :width="colMap.disp_applicant_manager_name[keyMap.columnWidth]"
            :label-class-name="colMap.disp_applicant_manager_name[keyMap.labelClass]"
            align="left"
            header-align="center"
            show-overflow-tooltip
            sortable="custom"
            class-name="disp_applicant_manager_name"
          />
        </el-table-column>
        <!-- 線名 -->
        <el-table-column
          prop="disp_line_name"
          :label="colMap.disp_line_name[keyMap.headerLabel]"
          :width="colMap.disp_line_name[keyMap.columnWidth]"
          :label-class-name="colMap.disp_line_name[keyMap.labelClass]"
          align="left"
          header-align="center"
          show-overflow-tooltip
          sortable="custom"
          class-name="disp_line_name"
          fixed
        />
        <!-- 駅間 -->
        <el-table-column
          :label="colMap.station_label[keyMap.headerLabel]"
          :width="colMap.station_label[keyMap.columnWidth]"
          header-align="center"
          fixed
        >
          <el-table-column
            prop="disp_start_station_name"
            :label="colMap.disp_start_station_name[keyMap.headerLabel]"
            :width="colMap.disp_start_station_name[keyMap.columnWidth]"
            :label-class-name="colMap.disp_start_station_name[keyMap.labelClass]"
            align="left"
            header-align="center"
            show-overflow-tooltip
            sortable="custom"
            class-name="disp_start_station_name"
          />
          <el-table-column
            prop="disp_end_station_name"
            :label="colMap.disp_end_station_name[keyMap.headerLabel]"
            :width="colMap.disp_end_station_name[keyMap.columnWidth]"
            :label-class-name="colMap.disp_end_station_name[keyMap.labelClass]"
            align="left"
            header-align="center"
            show-overflow-tooltip
            sortable="custom"
            class-name="disp_end_station_name"
          />
        </el-table-column>
        <!-- キロ程 -->
        <el-table-column
          prop="disp_meter"
          :label="colMap.disp_meter[keyMap.headerLabel]"
          :width="colMap.disp_meter[keyMap.columnWidth]"
          :label-class-name="colMap.disp_meter[keyMap.labelClass]"
          align="right"
          header-align="center"
          sortable="custom"
          class-name="disp_meter"
          fixed
        />
        <!-- 標題 -->
        <el-table-column
          prop="disp_applicant_title"
          :label="colMap.disp_applicant_title[keyMap.headerLabel]"
          :width="colMap.disp_applicant_title[keyMap.columnWidth]"
          :label-class-name="colMap.disp_applicant_title[keyMap.labelClass]"
          align="left"
          header-align="center"
          show-overflow-tooltip
          sortable="custom"
          class-name="disp_applicant_title"
          fixed
        />
        <!-- 工事種別 -->
        <el-table-column
          prop="disp_construction_type"
          :label="colMap.disp_construction_type[keyMap.headerLabel]"
          :width="colMap.disp_construction_type[keyMap.columnWidth]"
          :label-class-name="colMap.disp_construction_type[keyMap.labelClass]"
          align="left"
          header-align="center"
          show-overflow-tooltip
          sortable="custom"
          class-name="disp_construction_type"
        />
        <!-- 申請日 -->
        <el-table-column
          prop="disp_applicant_date"
          :label="colMap.disp_applicant_date[keyMap.headerLabel]"
          :width="colMap.disp_applicant_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_applicant_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          :class-name="'applicant_date' + (isDefaultSort ? ' is-default-sort' : '')"
        />
        <!-- 施工予定期間 -->
        <el-table-column :label="colMap.plan_date_label[keyMap.headerLabel]" header-align="center">
          <!-- 着手 -->
          <el-table-column
            prop="disp_start_plan_date"
            :label="colMap.disp_start_plan_date[keyMap.headerLabel]"
            :width="colMap.disp_start_plan_date[keyMap.columnWidth]"
            :label-class-name="colMap.disp_start_plan_date[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_start_plan_date"
          />
          <!-- しゅん功 -->
          <el-table-column
            prop="disp_end_plan_date"
            :label="colMap.disp_end_plan_date[keyMap.headerLabel]"
            :width="colMap.disp_end_plan_date[keyMap.columnWidth]"
            :label-class-name="colMap.disp_end_plan_date[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_end_plan_date"
          />
        </el-table-column>
        <!-- 問合せ中 -->
        <el-table-column
          prop="disp_applicant_contact_date"
          :label="colMap.disp_applicant_contact_date[keyMap.headerLabel]"
          :width="colMap.disp_applicant_contact_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_applicant_contact_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_applicant_contact_date"
        />
        <!-- 要否判断伺い -->
        <el-table-column
          prop="disp_judge_discussion_ask_date"
          :label="colMap.disp_judge_discussion_ask_date[keyMap.headerLabel]"
          :width="colMap.disp_judge_discussion_ask_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_judge_discussion_ask_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_judge_discussion_ask_date"
        />
        <!-- 要否判断承認 -->
        <el-table-column
          :label="colMap.judge_discussion_label[keyMap.headerLabel]"
          header-align="center"
          :label-class-name="colMap.judge_discussion_label[keyMap.labelClass]"
        >
          <!-- 承認日 -->
          <el-table-column
            prop="disp_judge_discussion_necessary_date"
            :label="colMap.disp_judge_discussion_necessary_date[keyMap.headerLabel]"
            :width="colMap.disp_judge_discussion_necessary_date[keyMap.columnWidth]"
            :label-class-name="colMap.disp_judge_discussion_necessary_date[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_judge_discussion_necessary_date"
          />
          <!-- 要否 -->
          <el-table-column
            prop="disp_judge_discussion_status"
            :label="colMap.disp_judge_discussion_status[keyMap.headerLabel]"
            :width="colMap.disp_judge_discussion_status[keyMap.columnWidth]"
            :label-class-name="colMap.disp_judge_discussion_status[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_judge_discussion_status"
          />
        </el-table-column>
        <!-- 協議不要連絡 -->
        <el-table-column
          prop="disp_judge_discussion_unnecessary_notice_date"
          :label="colMap.disp_judge_discussion_unnecessary_notice_date[keyMap.headerLabel]"
          :width="colMap.disp_judge_discussion_unnecessary_notice_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_judge_discussion_unnecessary_notice_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_judge_discussion_unnecessary_notice_date"
        />
        <!-- 事前協議日程調整依頼中-->
        <el-table-column
          prop="disp_prior_discussion_candidate_date"
          :label="colMap.disp_prior_discussion_candidate_date[keyMap.headerLabel]"
          :width="colMap.disp_prior_discussion_candidate_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_prior_discussion_candidate_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_prior_discussion_candidate_date"
        />
        <!-- 事前協議 -->
        <el-table-column :label="colMap.prior_discussion_label[keyMap.headerLabel]" align="center">
          <!-- 事前協議日程決定連絡 -->
          <el-table-column
            prop="disp_prior_discussion_decide_date"
            :label="colMap.disp_prior_discussion_decide_date[keyMap.headerLabel]"
            :width="colMap.disp_prior_discussion_decide_date[keyMap.columnWidth]"
            :label-class-name="colMap.disp_prior_discussion_decide_date[keyMap.labelClass]"
            align="center"
            sortable="custom"
            class-name="disp_prior_discussion_decide_date"
          />
          <!-- 事前協議・実施日 -->
          <el-table-column
            prop="disp_prior_discussion_schedule_date"
            :label="colMap.disp_prior_discussion_schedule_date[keyMap.headerLabel]"
            :width="colMap.disp_prior_discussion_schedule_date[keyMap.columnWidth]"
            :label-class-name="colMap.disp_prior_discussion_schedule_date[keyMap.labelClass]"
            align="center"
            sortable="custom"
            class-name="disp_prior_discussion_schedule_date"
          />
          <!-- 事前協議・開始時刻 -->
          <el-table-column
            prop="disp_prior_discussion_schedule_time"
            :label="colMap.disp_prior_discussion_schedule_time[keyMap.headerLabel]"
            :width="colMap.disp_prior_discussion_schedule_time[keyMap.columnWidth]"
            :label-class-name="colMap.disp_prior_discussion_schedule_time[keyMap.labelClass]"
            align="center"
            sortable="custom"
            class-name="disp_prior_discussion_schedule_time"
          />
          <!-- 事前協議・有無 -->
          <el-table-column
            prop="disp_prior_discussion_necessary"
            :label="colMap.disp_prior_discussion_necessary[keyMap.headerLabel]"
            :width="colMap.disp_prior_discussion_necessary[keyMap.columnWidth]"
            :label-class-name="colMap.disp_prior_discussion_necessary[keyMap.labelClass]"
            align="center"
            sortable="custom"
            class-name="disp_prior_discussion_necessary"
          />
        </el-table-column>
        <!-- 事前協議結果入力 -->
        <el-table-column
          prop="disp_prior_discussion_result_date"
          :label="colMap.disp_prior_discussion_result_date[keyMap.headerLabel]"
          :width="colMap.disp_prior_discussion_result_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_prior_discussion_result_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_prior_discussion_result_date"
        />
        <!-- 協議書 -->
        <!--協議書作成依頼 -->
        <el-table-column
          prop="disp_discussion_document_request_date"
          :label="colMap.disp_discussion_document_request_date[keyMap.headerLabel]"
          :width="colMap.disp_discussion_document_request_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_discussion_document_request_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_discussion_document_request_date"
        />
        <!--協議書確定通知 -->
        <el-table-column
          prop="disp_discussion_document_request_confirm_date"
          :label="colMap.disp_discussion_document_request_confirm_date[keyMap.headerLabel]"
          :width="colMap.disp_discussion_document_request_confirm_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_discussion_document_request_confirm_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_discussion_document_request_confirm_date"
        />
        <!--協議書受領連絡 -->
        <el-table-column
          prop="disp_discussion_document_receipt_date"
          :label="colMap.disp_discussion_document_receipt_date[keyMap.headerLabel]"
          :width="colMap.disp_discussion_document_receipt_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_discussion_document_receipt_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_discussion_document_receipt_date"
        />
        <!-- 現地立会 -->
        <!--現地立会JR関係者日程調整連絡 -->
        <el-table-column
          prop="disp_witness_schedule_jr_adjust_date"
          :label="colMap.disp_witness_schedule_jr_adjust_date[keyMap.headerLabel]"
          :width="colMap.disp_witness_schedule_jr_adjust_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_witness_schedule_jr_adjust_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_witness_schedule_jr_adjust_date"
        />
        <!--現地立会協議先日程調整連絡 -->
        <el-table-column
          prop="disp_witness_schedule_adjust_date"
          :label="colMap.disp_witness_schedule_adjust_date[keyMap.headerLabel]"
          :width="colMap.disp_witness_schedule_adjust_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_witness_schedule_adjust_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_witness_schedule_adjust_date"
        />
        <!--現地立会 -->
        <el-table-column :label="colMap.witness_schedule_label[keyMap.headerLabel]" header-align="center">
          <!--現地立会日程決定連絡 -->
          <el-table-column
            prop="disp_witness_schedule_decide_date"
            :label="colMap.disp_witness_schedule_decide_date[keyMap.headerLabel]"
            :width="colMap.disp_witness_schedule_decide_date[keyMap.columnWidth]"
            :label-class-name="colMap.disp_witness_schedule_decide_date[keyMap.labelClass]"
            align="center"
            sortable="custom"
            class-name="disp_witness_schedule_decide_date"
          />
          <!-- 現地立会・実施日 -->
          <el-table-column
            prop="disp_witness_schedule_date"
            :label="colMap.disp_witness_schedule_date[keyMap.headerLabel]"
            :width="colMap.disp_witness_schedule_date[keyMap.columnWidth]"
            :label-class-name="colMap.disp_witness_schedule_date[keyMap.labelClass]"
            align="center"
            sortable="custom"
            class-name="disp_witness_schedule_date"
          />
          <!--現地立会・開始時刻 -->
          <el-table-column
            prop="disp_witness_schedule_time"
            :label="colMap.disp_witness_schedule_time[keyMap.headerLabel]"
            :width="colMap.disp_witness_schedule_time[keyMap.columnWidth]"
            :label-class-name="colMap.disp_witness_schedule_time[keyMap.labelClass]"
            align="center"
            sortable="custom"
            class-name="disp_witness_schedule_time"
          /><!-- 現地立会・有無 -->
          <el-table-column
            prop="disp_witness_schedule_necessary"
            :label="colMap.disp_witness_schedule_necessary[keyMap.headerLabel]"
            :width="colMap.disp_witness_schedule_necessary[keyMap.columnWidth]"
            :label-class-name="colMap.disp_witness_schedule_necessary[keyMap.labelClass]"
            align="center"
            sortable="custom"
            class-name="disp_witness_schedule_necessary"
          />
        </el-table-column>
        <!--現地立会結果入力 -->
        <el-table-column
          prop="disp_witness_schedule_result_date"
          :label="colMap.disp_witness_schedule_result_date[keyMap.headerLabel]"
          :width="colMap.disp_witness_schedule_result_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_witness_schedule_result_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_witness_schedule_result_date"
        />
        <!-- 意見照会 -->
        <!-- 意見照会 -->
        <el-table-column
          prop="disp_witness_schedule_opinion_date"
          :label="colMap.disp_witness_schedule_opinion_date[keyMap.headerLabel]"
          :width="colMap.disp_witness_schedule_opinion_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_witness_schedule_opinion_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_witness_schedule_opinion_date"
        />
        <!-- 意見照会回答完了 -->
        <el-table-column
          prop="disp_witness_schedule_opinion_answer_date"
          :label="colMap.disp_witness_schedule_opinion_answer_date[keyMap.headerLabel]"
          :width="colMap.disp_witness_schedule_opinion_answer_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_witness_schedule_opinion_answer_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_witness_schedule_opinion_answer_date"
        />
        <!-- 回答案 -->
        <!-- 回答案伺 -->
        <el-table-column
          prop="disp_answer_ask_date"
          :label="colMap.disp_answer_ask_date[keyMap.headerLabel]"
          :width="colMap.disp_answer_ask_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_answer_ask_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_answer_ask_date"
        />
        <!-- 回答案送付(事前説明) -->
        <el-table-column
          prop="disp_answer_pre_explain_date"
          :label="colMap.disp_answer_pre_explain_date[keyMap.headerLabel]"
          :width="colMap.disp_answer_pre_explain_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_answer_pre_explain_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_answer_pre_explain_date"
        />
        <!-- 回答書送付 -->
        <el-table-column
          prop="disp_answer_date"
          :label="colMap.disp_answer_date[keyMap.headerLabel]"
          :width="colMap.disp_answer_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_answer_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_answer_date"
        />
        <!-- 回答請書確認通知 -->
        <el-table-column
          prop="disp_answer_receipt_notice_date"
          :label="colMap.disp_answer_receipt_notice_date[keyMap.headerLabel]"
          :width="colMap.disp_answer_receipt_notice_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_answer_receipt_notice_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_answer_receipt_notice_date"
        />
        <!-- 覚書 -->
        <!-- 覚書等作成依頼 -->
        <el-table-column
          prop="disp_adversaria_request_date"
          :label="colMap.disp_adversaria_request_date[keyMap.headerLabel]"
          :width="colMap.disp_adversaria_request_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_adversaria_request_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_adversaria_request_date"
        />
        <!-- 覚書等送付 -->
        <el-table-column
          prop="disp_adversaria_send_date"
          :label="colMap.disp_adversaria_send_date[keyMap.headerLabel]"
          :width="colMap.disp_adversaria_send_date[keyMap.columnWidth]"
          :label-class-name="colMap.disp_adversaria_send_date[keyMap.labelClass]"
          align="center"
          header-align="center"
          sortable="custom"
          class-name="disp_adversaria_send_date"
        />
        <!--状態 -->
        <el-table-column
          :label="colMap.status_label[keyMap.headerLabel]"
          header-align="center"
          :label-class-name="colMap.status_label[keyMap.labelClass]"
        >
          <!-- 事前協議 -->
          <el-table-column
            prop="disp_prior_discussion_status"
            :label="colMap.disp_prior_discussion_status[keyMap.headerLabel]"
            :width="colMap.disp_prior_discussion_status[keyMap.columnWidth]"
            :label-class-name="colMap.disp_prior_discussion_status[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_prior_discussion_status"
          />
          <!-- 協議書 -->
          <el-table-column
            prop="disp_discussion_document_status"
            :label="colMap.disp_discussion_document_status[keyMap.headerLabel]"
            :width="colMap.disp_discussion_document_status[keyMap.columnWidth]"
            :label-class-name="colMap.disp_discussion_document_status[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_discussion_document_status"
          />
          <!-- 現地立会意見照会 -->
          <el-table-column
            prop="disp_witness_status"
            :label="colMap.disp_witness_status[keyMap.headerLabel]"
            :width="colMap.disp_witness_status[keyMap.columnWidth]"
            :label-class-name="colMap.disp_witness_status[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_witness_status"
          />
          <!-- 回答 -->
          <el-table-column
            prop="disp_answer_status"
            :label="colMap.disp_answer_status[keyMap.headerLabel]"
            :width="colMap.disp_answer_status[keyMap.columnWidth]"
            :label-class-name="colMap.disp_answer_status[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_answer_status"
          />
          <!-- 覚書等 -->
          <el-table-column
            prop="disp_adversaria_status"
            :label="colMap.disp_adversaria_status[keyMap.headerLabel]"
            :width="colMap.disp_adversaria_status[keyMap.columnWidth]"
            :label-class-name="colMap.disp_adversaria_status[keyMap.labelClass]"
            align="center"
            header-align="center"
            sortable="custom"
            class-name="disp_adversaria_status"
          />
        </el-table-column>
      </el-table>
      <el-row class="my-3">
        <el-col :span="2">
          <router-link :to="{ name: 'ProximityAdd' }" class="add">
            <jr-button type="info" class="w-100"> 新規登録 </jr-button>
          </router-link>
        </el-col>
        <el-col :span="22">
          <el-pagination
            class="align-right"
            background
            layout="prev, pager, next"
            :total="dataCount"
            @current-change="currentChange"
            :page-size="PROXIMITY_SUMMARY_LIST_PAGINATE_BY"
            :current-page="currentPage"
          >
          </el-pagination>
        </el-col>
      </el-row>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, ref } from 'vue'
import { judgeDiscussion, priorDiscussion, discussionDocument, witness, answer, adversaria } from '@/constants/statuses'
import { AxiosResponse } from 'axios'
import { InlineResponse2001 as ProximitySearchResult } from '@/api'
import { ElForm, ElTable } from 'element-plus'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import JrDateRangePicker from '@/components/jr-parts/JrDateRangePicker.vue'
import InputKilo from '@/components/inputs/InputKilo.vue'
import DepartmentSelect from '@/components/inputs/DepartmentSelect.vue'
import LineSelect from '@/components/inputs/LineSelect.vue'
import StatusSelect from '@/components/inputs/StatusSelect.vue'
import StationSelect from '@/components/inputs/StationSelect.vue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import JrText from '@/components/jr-parts/JrText.vue'
import { proximityListRule } from '@/constants/rules'
import { ReadListRequest, PrintCreateRequest } from '@/requests/requestHeader'
import { LocationQueryValue, useRoute } from 'vue-router'
import { useStore, Store } from '@/store'
import { ProximitySearchForm } from '@/types/forms'
import {
  proximitySummaryColumnMap as colMap,
  proximitySummaryColumnKeyMap as keyMap,
  getSortColumn,
  colorsCellStyle,
  colorsCellClass,
} from '@/services/list'
import { RequestHeaderList, RequestHeaderSummaryListPrintResponse } from '@/api'
import {
  PROXIMITY_SUMMARY_LIST_PAGINATE_BY,
  PROXIMITY_SUMMARY_LIST_EXPORT_FILE_NAME,
} from '@/constants/backendConstants'
import { fileDownload } from '@/services/file'
import { dateToSimpleString } from '@/services/date'

interface ColumnInfo {
  order: string
  prop: string
}

export default defineComponent({
  name: 'DiscussionList',
  components: {
    JrButton,
    JrText,
    JrDateRangePicker,
    InputKilo,
    DepartmentSelect,
    LineSelect,
    StatusSelect,
    StationSelect,
    UserLoginWrapper,
  },
  setup() {
    const dataCount = ref<number | null>(1)
    const currentPage = ref<number | null>(1)
    const list = reactive<RequestHeaderList[]>([])
    const form = reactive<ProximitySearchForm>({
      applicant_number: '',
      applicant_date_start: '',
      applicant_date_end: '',
      department_id: null,
      department_name: '',
      department_code: '',
      applicant_title: '',
      line_code: '',
      meter_start: null,
      meter_end: null,
      station_id: null,
      judge_discussion_status: '',
      prior_discussion_status: '',
      discussion_document_status: '',
      witness_status: '',
      answer_status: '',
      adversaria_status: '',
      order_by: '',
      page: 1,
    })

    const route = useRoute()
    const store = useStore() as Store
    const elTableRef = ref<InstanceType<typeof ElTable>>()

    const getQueryParam = () => {
      const query = route.query
      if (returnedScreenJudgement(query.screen)) {
        const conditions = store.getters['proximityList/getSearchCondition']
        if (conditions != null) {
          form.applicant_number = conditions.applicant_number
          form.department_id = conditions.department_id
          form.department_name = conditions.department_name
          form.department_code = conditions.department_code
          form.applicant_title = conditions.applicant_title
          form.line_code = conditions.line_code
          form.meter_start = conditions.meter_start
          form.meter_end = conditions.meter_end
          form.station_id = conditions.station_id
          form.judge_discussion_status = conditions.judge_discussion_status
          form.prior_discussion_status = conditions.prior_discussion_status
          form.discussion_document_status = conditions.discussion_document_status
          form.witness_status = conditions.witness_status
          form.answer_status = conditions.answer_status
          form.adversaria_status = conditions.adversaria_status

          if (conditions.applicant_date_start != null && conditions.applicant_date_end != null) {
            form.applicant_date_start = conditions.applicant_date_start
            form.applicant_date_end = conditions.applicant_date_end
          }

          // 申請件名詳細からの遷移の場合
          if (query.screen === 'detail') {
            form.order_by = conditions.order_by
            form.page = conditions.page

            // テーブルソート
            setSortCondition(form.order_by)
          }
        }
      }
    }

    /**
     * 近接協議一覧出力
     */
    const print = async () => {
      const request = new PrintCreateRequest(
        form.applicant_number,
        form.applicant_date_start,
        form.applicant_date_end,
        form.department_id,
        form.applicant_title,
        form.line_code,
        form.meter_start,
        form.meter_end,
        form.station_id,
        form.judge_discussion_status,
        form.prior_discussion_status,
        form.discussion_document_status,
        form.witness_status,
        form.answer_status,
        form.adversaria_status,
        form.order_by,
        form.page
      )

      await request.exec()

      if (request.success) {
        const { data } = request.getResponse() as AxiosResponse<RequestHeaderSummaryListPrintResponse>
        const downloadFileName =
          PROXIMITY_SUMMARY_LIST_EXPORT_FILE_NAME + '_' + dateToSimpleString(new Date()) + '.xlsx'
        fileDownload(data, downloadFileName)
      }
    }

    const search = async (pageReset = false) => {
      if (!validate()) {
        return false
      }
      if (pageReset) {
        form.page = 1
      }

      const request = new ReadListRequest(
        form.applicant_number,
        form.applicant_date_start,
        form.applicant_date_end,
        form.department_id,
        form.applicant_title,
        form.line_code,
        form.meter_start,
        form.meter_end,
        form.station_id,
        form.judge_discussion_status,
        form.prior_discussion_status,
        form.discussion_document_status,
        form.witness_status,
        form.answer_status,
        form.adversaria_status,
        form.order_by,
        form.page
      )

      await request.exec()
      if (request.success) {
        const { data } = request.getResponse() as AxiosResponse<ProximitySearchResult>
        // 総件数を取得
        dataCount.value = data.count

        // ページネーション設定
        currentPage.value = form.page

        // 一覧データ配置
        list.splice(0)
        list.push(...data.results)

        // 検索情報保持
        store.commit('proximityList/setSearchCondition', form)
      }
    }

    // ページネーション変更
    const currentChange = (val: number) => {
      form.page = val
      search()

      // ページを変える時にトップにスクロールを戻す
      if (elTableRef.value) {
        let bodyWrapper = elTableRef.value.$refs.bodyWrapper as Record<keyof HTMLElement, unknown>
        if (typeof bodyWrapper.scrollTop === 'number') {
          bodyWrapper.scrollTop = 0
        }
      }
    }

    // テーブルソート
    const sortChange = (column: ColumnInfo) => {
      let sortBy: string = getSortColumn(column.prop)
      if (column.order === 'descending' && sortBy != '') {
        form.order_by = '-' + sortBy
      } else {
        form.order_by = sortBy
      }
      form.page = 1
      search()
    }
    const sortKey = ref<string | null>(null)
    const orderCondition = ref<string | null>(null)
    const setSortCondition = (order: string | null) => {
      if (!order) {
        sortKey.value = 'applicant_time'
        orderCondition.value = 'descending'
      } else if (order.includes('-')) {
        sortKey.value = order.replace('-', '')
        orderCondition.value = 'descending'
      } else {
        sortKey.value = order
        orderCondition.value = 'ascending'
      }
    }
    // デフォルトソート(申請日時降順)かどうか デフォルト時に降順に赤マークが付与されないため、この判定からクラスを付与しcssで色を付ける
    const isDefaultSort = computed(() => {
      return form.order_by === ''
    })

    const formRef = ref<InstanceType<typeof ElForm>>()
    // バリデーション
    const validate = () => {
      let result = true
      if (formRef.value) {
        formRef.value.validate((valid) => {
          if (!valid) {
            // チェックNG
            result = false
          }
        })
      }
      return result
    }

    // 詳細画面や新規登録画面から返ってきたかを判定
    const returnedScreenJudgement = (screen: LocationQueryValue | LocationQueryValue[]) => {
      if (screen === 'detail' || screen === 'add') {
        return true
      } else {
        return false
      }
    }

    // 検索条件復元
    getQueryParam()
    search()
    return {
      formRef,
      rules: proximityListRule,
      judgeDiscussion,
      priorDiscussion,
      discussionDocument,
      witness,
      answer,
      adversaria,
      search,
      dataCount,
      currentPage,
      list,
      form,
      currentChange,
      getQueryParam,
      sortChange,
      sortKey,
      orderCondition,
      validate,
      PROXIMITY_SUMMARY_LIST_PAGINATE_BY,
      isDefaultSort,
      colorsCellClass,
      colorsCellStyle,
      colMap,
      keyMap,
      print,
      elTableRef,
    }
  },
})
</script>

<style lang="scss" scoped>
.el-collapse {
  border-top: none;
  border-bottom: none;
}

.el-table {
  ::v-deep(table) {
    border-collapse: collapse !important;
  }
  ::v-deep(.is-default-sort .sort-caret.descending) {
    border-top-color: #eb5f60;
  }
  ::v-deep(.header-featured-bk-color) {
    background: #fff2cc;
  }
  ::v-deep(.header-status-bk-color) {
    background: #ddeeff;
  }
  ::v-deep(.br-class) {
    white-space: pre-line;
  }
  ::v-deep(.updated-status-color) {
    color: red;
  }
}

// iPadで固定行がずれて見える問題を修正したもの
.table-header-fixed-for-iPad {
  ::v-deep(.el-table__body) {
    width: 100% !important;
    table-layout: fixed !important;
    .cell.el-tooltip {
      width: auto !important;
    }
  }
}
</style>
<style lang="scss">
.list-card-class {
  // 出力・検索ボタン
  .export-button {
    background-color: green;
    width: 90%;
  }
  .search {
    width: 90%;
  }
  // 縦幅、横幅調整 ※余白削除のため
  > .el-card__header,
  > .el-card__body {
    padding: 5px 5px 5px 10px;
  }
  .el-collapse-item__header {
    height: 30px;
  }
  > .el-card__header {
    font-size: 0.875rem;
  }
  .el-collapse-item__content {
    padding: 0px;
  }
}

.list-table-class {
  // テーブルヘッダー・セル余白調整
  > .el-table__header-wrapper th,
  > .el-table__fixed th {
    border: 0.5px solid #444444;
    padding: 0px 2px;
  }
  > .el-table__header-wrapper th > .cell,
  > .el-table__fixed th > .cell {
    padding: 0px;
    line-height: 0.6rem;
    font-size: 0.4rem;
  }
  > .el-table__body-wrapper td,
  > .el-table__fixed td {
    border: 0.5px solid #444444;
    padding: 0px 2px;
  }
  > .el-table__body-wrapper td > .cell,
  > .el-table__fixed td > .cell {
    padding: 0px;
    line-height: 1rem;
  }

  // セル背景色
  .cell-featured-bk-color {
    background: #fff2cc; // yellow
  }
  .cell-status-bk-color {
    background: #ddeeff; // lightblue
  }
}
</style>
